import { useQuery } from '@apollo/client';
import { query } from './query';
export function useTeam(id) {
    const { data, loading, error } = useQuery(query, {
        variables: { id },
    });
    const team = data === null || data === void 0 ? void 0 : data.team;
    return { team, loading, error };
}
